import { makeStyles } from "@material-ui/core/styles";

export const newParticipantStyles = makeStyles((theme) => ({
  container: {
    margin: 0,
    padding: "32px 0 60px 0",
  },
  gridContainer: {
    margin: 0,
    [theme.breakpoints.down("xs")]: {
      width: "auto",
    },
  },
  customTextfield: {
    "& .MuiFormLabel-root": {
      fontFamily: "Inter",
      fontStyle: "normal",
      fontWeight: 700,
      fontSize: theme.typography.pxToRem(14),
      color: theme.palette.common.black,
    },
    "& .MuiOutlinedInput-root": {
      maxWidth: "364px",
      fontFamily: "Inter",
      fontStyle: "normal",
      fontWeight: 400,
      color: theme.palette.common.black,
      borderColor: theme.palette.common.black,
      "& fieldset": {
        borderColor: theme.palette.common.black,
      },
      "&:hover fieldset": {
        borderColor: theme.palette.common.black,
      },
      "&.Mui-focused fieldset": {
        borderColor: theme.palette.common.black,
        borderWidth: "1px 1px 4px 1px",
      },
    },
    "& label.Mui-focused": {
      color: theme.palette.common.black,
    },
    "& .MuiFormHelperText-root.Mui-error": {
      marginLeft: 0,
    },
  },
  endAdornment: {
    padding: 0,
  },
  passwordAcceptedIcon: {
    color: "#0ABF52",
  },
  showPasswordIcon: {
    fill: theme.palette.common.black,
  },
  changePsswdBtn: {
    fontFamily: "Inter",
    padding: "8px 24px",
    borderRadius: "100px",
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    marginRight: 10,
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
      opacity: "90%",
    },
  },
  errorMessage: {
    fontFamily: "Inter",
    color: "red",
  },
  errorList: {
    paddingInlineStart: "20px",
    margin: "4px 0",
  },
  inputBox: {
    display: "flex",
    flexDirection: "row",
  },
}));
